<template>
  <div class="common_activity" :class="{ isiOSX: isiOSX }">
    <van-nav-bar title="销巴装饰" :fixed="true" />
    <img
      @click="goBack()"
      class="reback"
      src="../../assets/myInvest/reback.png"
    />
    <van-row>
      <van-col span="24" class="content" :style="paddT">
        <img src="./../../assets/decoration/index/index1.png" alt="" />
        <img src="./../../assets/decoration/index/index2.png" alt="" />
        <img src="./../../assets/decoration/index/index3.png" alt="" />
        <img src="./../../assets/decoration/index/index4.png" alt="" />
        <img src="./../../assets/decoration/index/index5.png" alt="" />
      </van-col>
    </van-row>
    <!-- 装饰订单图标 -->
    <img
      class="decorationOrder"
      @click="toDecorationOrder()"
      src="../../assets/decoration/order.png"
      alt=""
    />
    <!-- 装饰入口按钮 -->
    <div class="decoration">
      <!-- 只有代理人 -->
      <div class="agent" v-if="!is_partner">
        <img
          @click="toDecorationDeputy()"
          src="../../assets/decoration/agent1.png"
          alt=""
        />
      </div>
      <!-- 代理人合伙人都存在 -->
      <div class="agentAndPartener" v-else>
        <img
          @click="toDecorationDeputy()"
          src="../../assets/decoration/agent2.png"
          alt=""
        />
        <img
          @click="toDecorationcityPartner()"
          src="../../assets/decoration/partner2.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isiOSX: false,
      paddT: { paddingTop: "68px" }, //app内
      is_partner: false,
      equipment: null, //10安卓 11ios
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.isiOSX) {
      //app内齐刘海
      this.paddT = { paddingTop: "88px" };
    }
    this.deductionUA();
    this.$api.setToken(this.$route.query.token);
    this.getCityPartner();
  },
  methods: {
    goBack() {
      // 返回app首页
      if (this.equipment == 10) {
        this.params(0, 0, "goHome");
      } else {
        this.params("", "", "decorateToHome");
      }
    },
    // 判断手机机型
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.equipment = 11;
      } else if (/android/.test(ua)) {
        this.equipment = 10;
      }
    },
    // 判断是否显示合伙人入口
    getCityPartner() {
      this.$api.get("decoration/member/city/partner/is/partner").then((res) => {
        this.is_partner = res.is_partner;
      });
    },
    // 跳转装饰代理人
    toDecorationDeputy() {
      this.$router.push({
        path: "/decoration/deputy/index",
        query: {
          token: this.$route.query.token,
        },
      });
    },
    // 跳转装饰合伙人
    toDecorationcityPartner() {
      this.$router.push({
        path: "/decoration/cityPartner/index",
        query: {
          token: this.$route.query.token,
        },
      });
    },
    // 跳转装饰订单
    toDecorationOrder() {
      this.$router.push({
        path: "/decoration/order/orderList",
        query: {
          token: this.$route.query.token,
        },
      });
    },
  },
};
</script>

<style lang="less">
.common_activity {
  background: #ffffff;
  min-height: 100%;
  .van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 24px;
    box-shadow: 0 1px 0 #eee;
    .van-nav-bar__title {
      color: #333;
      font-size: 17px;
      font-weight: 700;
    }
  }
  .reback {
    width: 15px;
    padding: 12px 15px;
    position: fixed;
    top: 27px;
    left: 0;
    z-index: 1;
  }
  .content {
    width: 100%;
    background: #ffffff;
    img {
      width: 100% !important;
      display: block;
    }
  }
}

.isiOSX {
  .van-nav-bar {
    padding-top: 44px;
  }
  .reback {
    top: 47px;
  }
}
.decorationOrder {
  width: 64px;
  height: 64px;
  position: fixed;
  bottom: 101px;
  right: 10px;
}
.decoration {
  width: 100%;
  height: 64px;
  position: fixed;
  left: 0;
  bottom: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    flex: 1;
    margin: 0 16px;
    img {
      height: 64px;
    }
  }
  .agent {
    img {
      width: 100%;
    }
  }
  .agentAndPartener {
    img {
      width: 50%;
    }
  }
}
</style>
